(function (app, ng) {
    app.component("configureDetermineWorkflow",
        {
            controller: configureDetermineWorkflowController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/Workflows/Determine/template.html",
            bindings: {
                transactionGroup: "=",
                requiredDetermineDocuments: "=",
                determinePoints: "=",
                publishedTransactionGroup: "<",
                onSave: "&"
            }
        });

    configureDetermineWorkflowController.$inject = ["_", "transactionGroupApi", "figToaster", "figToastContainers", "fundingSources"];
    function configureDetermineWorkflowController(_, transactionGroupApi, figToaster, figToastContainers, fundingSources) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                fundingSources: fundingSources,
                determinePointsInfo: [
                    { Name: "Required Documents", Detail: "Uploads needed to proceed to the next step", Value: "DetermineDocuments" },
                    { Name: "RightBRIDGE", Detail: "Product Comparison Tool", Value: "Rightbridge" }
                ],
                addRequiredDocument: addRequiredDocument,
                removeRequiredDocument: removeRequiredDocument,
                updateTransactionGroup: updateTransactionGroup,
                checkValidName: checkValidName,
                setDeterminePointActiveState: setDeterminePointActiveState,
                updateDocumentConditional: updateDocumentConditional,
                updateDocumentFundingSource: updateDocumentFundingSource
            });

        this.$onInit = function () {
            checkUnpublishedChanges();

            $ctrl.selectedDeterminePoint = $ctrl.determinePoints[0].Value;
            if ($ctrl.transactionGroup.RequiredDetermineDocuments) {
                ng.forEach($ctrl.transactionGroup.RequiredDetermineDocuments,
                    function (row) {
                        if (row.FundingSources && row.FundingSources.length)
                            row.IsConditional = true;
                    });
            }
        };

        function setDeterminePointActiveState(index) {
            $ctrl.determinePoints[index].Unpublished = !$ctrl.determinePoints[index].Unpublished;
            updateUnpublishedChanges($ctrl.determinePoints[index]);
            updateTransactionGroup();
        }

        function updateTransactionGroup() {
            $ctrl.transactionGroup.DeterminePoints = [];
            ng.forEach($ctrl.determinePoints,
                function (determinePoint) {
                    if (determinePoint.IsActive)
                        $ctrl.transactionGroup.DeterminePoints.push(determinePoint.Value);
                });
            
            $ctrl.transactionGroup.RequiredDetermineDocuments = [];
            ng.forEach($ctrl.requiredDetermineDocuments,
                function (document) {
                    $ctrl.transactionGroup.RequiredDetermineDocuments.push({
                        Value: document.Value,
                        FundingSources: document.FundingSources
                    });
                });

            if ($ctrl.transactionGroup.RequiredDetermineDocuments.length === 0 &&
                $ctrl.transactionGroup.DeterminePoints.includes("DetermineDocuments")) {
                var index = _.findIndex($ctrl.transactionGroup.DeterminePoints,
                    function (determinePoint) {
                        return determinePoint === "DetermineDocuments";
                    });

                $ctrl.transactionGroup.DeterminePoints.splice(index, 1);
            }

            console.log($ctrl.transactionGroup);
            transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
        };

        function addRequiredDocument() {
            $ctrl.requiredDetermineDocuments.push({ Value: $ctrl.UI.documentName, IsConditional: false, FundingSources: [], Unpublished: true });
            $ctrl.UI.documentName = "";
            $ctrl.transactionGroup.UnpublishedChanges++;
            updateTransactionGroup();
        }

        function removeRequiredDocument(document, index) {
            figToaster.showYesNo("Are you sure you would like to delete " + document.Value + "?",
                "bottom center",
                figToastContainers.get("configure-transaction-group"),
                true).then(function (response) {
                    if (!response) return;

                $ctrl.transactionGroup.UnpublishedChanges++;
                    $ctrl.requiredDetermineDocuments.splice(index, 1);
                    updateTransactionGroup();
                });
        }

        function checkValidName(document) {
            if (document.NewName === "") {
                document.NewName = document.Name;
            } else {
                document.Value = document.NewName;
            }

            delete document.NewName;
        }

        function updateUnpublishedChanges(item) {
            if (item.Unpublished === true)
                $ctrl.transactionGroup.UnpublishedChanges++;
            else
                $ctrl.transactionGroup.UnpublishedChanges--;
        }

        function checkUnpublishedChanges() {
            if ($ctrl.publishedTransactionGroup && $ctrl.transactionGroup) {

                ng.forEach($ctrl.transactionGroup.DeterminePoints, function(point) {
                    if (!_.find($ctrl.publishedTransactionGroup.DeterminePoints, function(p) {
                        return p === point;
                    })) {
                        _.find($ctrl.determinePoints, function(p) {
                            return p.Value === point;
                        }).Unpublished = true;
                    }
                });

                ng.forEach($ctrl.publishedTransactionGroup.DeterminePoints, function(point) {
                    if (!_.find($ctrl.transactionGroup.DeterminePoints, function(p) {
                        return p === point;
                    })) {
                        _.find($ctrl.determinePoints, function(p) {
                            return p.Value === point;
                        }).Unpublished = true;
                    }
                });

                ng.forEach($ctrl.transactionGroup.RequiredDetermineDocuments, function(doc) {
                    if (!_.find($ctrl.publishedTransactionGroup.RequiredDetermineDocuments, function(d) {
                        return d.Value === doc.Value && _.isEqual(d.FundingSources.sort(), doc.FundingSources.sort());
                    })) {
                        _.find($ctrl.requiredDetermineDocuments, function(d) {
                            return d.Value === doc.Value && _.isEqual(d.FundingSources.sort(), doc.FundingSources.sort());
                        }).Unpublished = true;
                    }
                });

                ng.forEach($ctrl.publishedTransactionGroup.RequiredDetermineDocuments, function(doc) {
                    if (!_.find($ctrl.transactionGroup.RequiredDetermineDocuments, function(d) {
                        return d.Value === doc.Value && _.isEqual(d.FundingSources.sort(), doc.FundingSources.sort());
                    })) {
                        _.find($ctrl.requiredDetermineDocuments, function(d) {
                            return d.Value === doc.Value && _.isEqual(d.FundingSources.sort(), doc.FundingSources.sort());
                        }).Unpublished = true;
                    }
                });
            } else {
                ng.forEach($ctrl.determinePoints, function (point) {
                    if (point.IsActive)
                        point.Unpublished = true;
                });

                ng.forEach($ctrl.transactionGroup.RequiredDetermineDocuments, function (doc) {
                    doc.Unpublished = true;
                });
            }
        }

        function updateDocumentConditional(document) {
            if (document.IsConditional) {
                document.IsConditional = false;
                document.FundingSources = [];
            } else {
                document.IsConditional = true;
            }
            updateTransactionGroup();
        }

        function updateDocumentFundingSource(document, fundingSource) {
            var index = _.findIndex(document.FundingSources,
                function(row) {
                    return row === fundingSource.Value;
                });
            if (index === -1)
                document.FundingSources.push(fundingSource.Value);
            else
                document.FundingSources.splice(index, 1);
            updateTransactionGroup();
        }
    };
})(window.app, window.angular); //jshint ignore:line